export function loadGroupList(query) {
  return {
    type: 'LOAD_GROUP_LIST',
    query,
    willReload: !!query,
  };
}

export function loadGroupListCompletion(error, list) {
  return {
    type: 'LOAD_GROUP_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadGroup(id, isOrder) {
  return {
    type: 'LOAD_GROUP',
    id,
    isOrder,
  };
}

export function loadGroupCompletion(error, data) {
  return {
    type: 'LOAD_GROUP_COMPLETION',
    error,
    data,
  };
}

export function loadGroupWaitList(productId) {
  return {
    type: 'LOAD_GROUP_WAIT_LIST',
    productId,
  };
}

export function loadGroupWaitListCompletion(error, list, count) {
  return {
    type: 'LOAD_GROUP_WAIT_LIST_COMPLETION',
    error,
    list,
    count,
  };
}

export function overGroup(groupId) {
  return {
    type: 'OVER_GROUP',
    groupId,
  }
}

export function overGroupCompletion(error, data) {
  return {
    type: 'OVER_GROUP_COMPLETION',
    error,
    data,
  }
}

export function loadGroupThemeBannerList(client) {
  return {
    type: 'LOAD_GROUP_THEME_BANNER_LIST',
    client
  }
}

export function loadGroupThemeBannerListCompletion(error, list) {
  return {
    type: 'LOAD_GROUP_THEME_BANNER_LIST_COMPLETION',
    error,
    list
  }
}

export function loadGroupThemeList() {
  return {
    type: 'LOAD_GROUP_THEME_LIST',
  }
}

export function loadGroupThemeListCompletion(error, list) {
  return {
    type: 'LOAD_GROUP_THEME_LIST_COMPLETION',
    error,
    list
  }
}

export function loadGroupThemeTipShow() {
  return {
    type: 'LOAD_GROUP_THEME_TIP_SHOW',
  }
}

export function loadGroupThemeTipShowCompletion(error, data) {
  return {
    type: 'LOAD_GROUP_THEME_TIP_SHOW_COMPLETION',
    error,
    data
  }
}

export function syncGroupThemeTipShow(value) {
  return {
    type: 'SYNC_GROUP_THEME_TIP_SHOW',
    value
  }
}